function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23.85,50.578L23.85,50.577C23.857,48.021 22.831,45.567 21.009,43.777C17.976,40.816 16.264,36.752 16.264,32.514C16.264,24.05 23.092,17.023 31.552,16.78C31.553,16.78 31.553,16.78 31.553,16.78C31.701,16.776 31.848,16.774 31.996,16.774C40.631,16.774 47.736,23.879 47.736,32.514C47.736,36.767 46.012,40.843 42.961,43.806C41.155,45.576 40.141,48.004 40.15,50.533L40.15,50.536L40.15,50.536C40.15,50.636 40.137,50.726 40.115,50.806C39.876,52.445 38.45,53.72 36.75,53.72L27.25,53.72C25.578,53.72 24.172,52.487 23.898,50.889C23.868,50.798 23.85,50.695 23.85,50.578ZM38.232,50.316C38.279,47.349 39.495,44.515 41.618,42.434C41.619,42.433 41.62,42.432 41.621,42.431C44.302,39.83 45.816,36.249 45.816,32.514C45.816,24.933 39.578,18.694 31.996,18.694C31.867,18.694 31.737,18.696 31.607,18.7L31.607,18.7C24.179,18.913 18.184,25.082 18.184,32.514C18.184,36.235 19.688,39.803 22.351,42.403C22.351,42.404 22.352,42.404 22.353,42.405C24.46,44.475 25.681,47.28 25.765,50.224L25.767,50.244C25.768,50.255 25.769,50.267 25.769,50.279L25.77,50.314L25.77,50.314L25.77,50.321C25.77,51.132 26.438,51.8 27.25,51.8L36.75,51.8C37.562,51.8 38.23,51.132 38.23,50.321L38.23,50.316L38.23,50.316L38.23,50.314L38.232,50.316Z",
    style: {
      fill: "rgb(252,177,49)",
      stroke: "rgb(252,177,49)",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.57,31.53C22.57,27.059 26.249,23.38 30.72,23.38C31.25,23.38 31.68,22.95 31.68,22.42C31.68,21.89 31.25,21.46 30.72,21.46C25.196,21.46 20.65,26.006 20.65,31.53C20.65,32.06 21.08,32.49 21.61,32.49C22.14,32.49 22.57,32.06 22.57,31.53Z",
    style: {
      fill: "rgb(252,177,49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.82,57.12L37.18,57.12C37.71,57.12 38.14,56.69 38.14,56.16C38.14,55.63 37.71,55.2 37.18,55.2L26.82,55.2C26.29,55.2 25.86,55.63 25.86,56.16C25.86,56.69 26.29,57.12 26.82,57.12Z",
    style: {
      fill: "rgb(252,177,49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.67,60.22L35.33,60.22C35.86,60.22 36.29,59.79 36.29,59.26C36.29,58.73 35.86,58.3 35.33,58.3L28.67,58.3C28.14,58.3 27.71,58.73 27.71,59.26C27.71,59.79 28.14,60.22 28.67,60.22Z",
    style: {
      fill: "rgb(252,177,49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.19,63.45L33.81,63.45C34.34,63.45 34.77,63.02 34.77,62.49C34.77,61.96 34.34,61.53 33.81,61.53L30.19,61.53C29.66,61.53 29.23,61.96 29.23,62.49C29.23,63.02 29.66,63.45 30.19,63.45Z",
    style: {
      fill: "rgb(252,177,49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.96,9.29L32.96,1.51C32.96,0.98 32.53,0.55 32,0.55C31.47,0.55 31.04,0.98 31.04,1.51L31.04,9.29C31.04,9.82 31.47,10.25 32,10.25C32.53,10.25 32.96,9.82 32.96,9.29Z",
    style: {
      fill: "rgb(252,177,49)",
      stroke: "rgb(252,177,49)",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.459,15.331L10.959,9.831C10.584,9.457 9.976,9.457 9.601,9.831C9.227,10.206 9.227,10.814 9.601,11.189L15.101,16.689C15.476,17.063 16.084,17.063 16.459,16.689C16.833,16.314 16.833,15.706 16.459,15.331Z",
    style: {
      fill: "rgb(252,177,49)",
      stroke: "rgb(252,177,49)",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.459,15.331L10.959,9.831C10.584,9.457 9.976,9.457 9.601,9.831C9.227,10.206 9.227,10.814 9.601,11.189L15.101,16.689C15.476,17.063 16.084,17.063 16.459,16.689C16.833,16.314 16.833,15.706 16.459,15.331Z",
    style: {
      fill: "rgb(252,177,49)",
      stroke: "rgb(252,177,49)",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07,31.27L1.28,31.27C0.75,31.27 0.32,31.7 0.32,32.23C0.32,32.76 0.75,33.19 1.28,33.19L9.07,33.19C9.6,33.19 10.03,32.76 10.03,32.23C10.03,31.7 9.6,31.27 9.07,31.27Z",
    style: {
      fill: "rgb(252,177,49)",
      stroke: "rgb(252,177,49)",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.93,33.19L62.72,33.19C63.25,33.19 63.68,32.76 63.68,32.23C63.68,31.7 63.25,31.27 62.72,31.27L54.93,31.27C54.4,31.27 53.97,31.7 53.97,32.23C53.97,32.76 54.4,33.19 54.93,33.19Z",
    style: {
      fill: "rgb(252,177,49)",
      stroke: "rgb(252,177,49)",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.899,16.689L54.399,11.189C54.773,10.814 54.773,10.206 54.399,9.831C54.024,9.457 53.416,9.457 53.041,9.831L47.541,15.331C47.167,15.706 47.167,16.314 47.541,16.689C47.916,17.063 48.524,17.063 48.899,16.689Z",
    style: {
      fill: "rgb(252,177,49)",
      stroke: "rgb(252,177,49)",
      strokeWidth: 4
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.bc79ef6d.svg";
export { ForwardRef as ReactComponent };